module.exports = __webpack_public_path__ + "fonts/ee72f98.eot";